/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Heading, Button, ButtonGroup, DisplayHtmlContent } from 'sarsaparilla';

import { useAuthModalScreen } from '../AuthModalScreenContext';

interface AccountServiceDisabledScreenProps {
    // Notice data would come from /api/accounts/status
    notice?: {
        notice_title?: string;
        notice_body?: string; // HTML and maybe also URL encoded
    };
}

export function AccountServiceDisabledScreen({
    notice,
}: AccountServiceDisabledScreenProps) {
    const { closeModal } = useAuthModalScreen();

    const title =
        typeof notice?.notice_title === 'string' && notice.notice_title.length > 0
            ? notice.notice_title
            : undefined;
    const bodyHTML =
        notice?.notice_body && notice.notice_body.length > 0
            ? decodeURIComponent(notice.notice_body)
            : undefined;

    return (
        <div className="p-sm-4">
            {title && bodyHTML ? (
                <>
                    <Heading
                        headingLevel={1}
                        appearance="h4"
                        className="mb-2 pr-4"
                        id="modal-heading"
                    >
                        {title}
                    </Heading>

                    <DisplayHtmlContent html={bodyHTML} />
                </>
            ) : (
                <>
                    <Heading
                        headingLevel={1}
                        appearance="h4"
                        className="mb-3 pr-4"
                        id="modal-heading"
                    >
                        We‘ll be Right Back
                    </Heading>

                    <p className="text-lg">
                        We‘ve temporarily disabled logging in while we perform maintenance
                        on {process.env.SITE_NAME}.
                    </p>

                    <p className="text-lg">Please check back soon.</p>
                </>
            )}

            <ButtonGroup align="right">
                <Button
                    className="mt-3"
                    onClick={() => {
                        closeModal();
                    }}
                >
                    Close
                </Button>
            </ButtonGroup>
        </div>
    );
}
